"use strict";
"use client";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoComplete = void 0;
const react_1 = __importStar(require("react"));
const utils_1 = require("../utils");
const navigation_1 = require("next/navigation");
const AutoComplete = ({ className = "", submitLabel = "Submit", closeLabel = "Close", children, placeHolderText = "Search...", value = "", isControlledOpen, autoSuggestion, setIsControlledOpen, onChange, onFocus, onBlur, handleClose, handleSubmit, overlay, onKeyDown, disable, ...props }) => {
    const [isDropDownOpen, setIsDropDownOpen] = (0, react_1.useState)(false);
    const dropDownRef = (0, react_1.useRef)(null);
    const inputRef = (0, react_1.useRef)(null);
    const previousActiveElement = (0, react_1.useRef)(null);
    const closeIconRef = (0, react_1.useRef)(null);
    const pathname = (0, navigation_1.usePathname)();
    const effectiveIsOpen = isControlledOpen ?? isDropDownOpen;
    const closeDropDown = () => {
        if (setIsControlledOpen) {
            setIsControlledOpen(false);
        }
        else {
            setIsDropDownOpen(false);
        }
    };
    const handleClickOutside = (event) => {
        if (dropDownRef.current &&
            !dropDownRef.current.contains(event.target) &&
            inputRef.current &&
            !inputRef.current.contains(event.target) &&
            closeIconRef.current &&
            !closeIconRef.current.contains(event.target)) {
            closeDropDown();
        }
    };
    (0, react_1.useEffect)(() => {
        if (effectiveIsOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [effectiveIsOpen]);
    (0, react_1.useEffect)(() => {
        closeDropDown();
    }, [pathname]);
    (0, react_1.useEffect)(() => {
        if (effectiveIsOpen && overlay) {
            previousActiveElement.current = document.activeElement;
            inputRef.current?.focus();
            document.body.style.overflow = 'hidden'; // Prevent background scrolling
        }
        else {
            document.body.style.overflow = '';
            previousActiveElement.current?.blur();
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [effectiveIsOpen, overlay]);
    const handleKeyDown = (e) => {
        if (e.key === "Escape")
            closeDropDown();
    };
    (0, react_1.useEffect)(() => {
        if (effectiveIsOpen) {
            document.addEventListener("keydown", handleKeyDown);
        }
        else {
            document.removeEventListener("keydown", handleKeyDown);
        }
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [effectiveIsOpen]);
    const handleBlur = (e) => {
        const relatedTarget = e.relatedTarget;
        if (!dropDownRef.current?.contains(relatedTarget) &&
            !inputRef.current?.contains(relatedTarget) &&
            !closeIconRef.current?.contains(relatedTarget)) {
            closeDropDown();
        }
        if (onBlur)
            onBlur();
    };
    const handleScroll = throttle((e) => {
        if ('ontouchstart' in window && navigator.maxTouchPoints > 0 && e.type == 'scroll') {
            inputRef.current?.blur();
        }
    }, 200);
    const openDropdown = () => {
        if (setIsControlledOpen) {
            setIsControlledOpen(true);
        }
        else {
            setIsDropDownOpen(true);
        }
    };
    (0, react_1.useEffect)(() => {
        if (!dropDownRef.current)
            return;
        const scrollables = dropDownRef.current.querySelectorAll("div");
        scrollables.forEach((el) => {
            if (el.scrollHeight > el.clientHeight) {
                el.addEventListener("scroll", handleScroll);
            }
        });
        return () => {
            scrollables.forEach((el) => {
                el.removeEventListener("scroll", handleScroll);
            });
        };
    }, [children, effectiveIsOpen]);
    function throttle(fx, time) {
        let id = null;
        let arg = [];
        return function (x) {
            arg[0] = x;
            if (!id) {
                id = setTimeout(() => {
                    fx(arg[0]);
                    id = null;
                }, time);
            }
            console.log({ id });
        };
    }
    return (react_1.default.createElement("div", { className: (0, utils_1.cn)(`autocomplete-search relative ${className}`) },
        react_1.default.createElement("div", { className: "relative inputWrapper" },
            react_1.default.createElement("form", { role: "form", onSubmit: (e) => {
                    if (handleSubmit)
                        handleSubmit(e);
                } },
                react_1.default.createElement("label", { htmlFor: "Search Recipes", className: "sr-only" }, "Search Recipes"),
                react_1.default.createElement("input", { id: "Search Recipes", type: "text", disabled: disable, placeholder: placeHolderText, value: value, onChange: (e) => {
                        if (onChange)
                            onChange(e);
                    }, onFocus: () => {
                        openDropdown();
                        if (onFocus)
                            onFocus();
                    }, onKeyDown: onKeyDown, onBlur: (e) => {
                        if (onBlur)
                            onBlur();
                        if (!dropDownRef.current?.contains(e.relatedTarget)) {
                            inputRef.current?.blur();
                        }
                    }, ref: inputRef, className: "search-input w-full relative z-[9] text-[#313131] placeholder:text-[#313131]\r\n              border-[#C4C4C4] py-[15px] rounded-[4px]", ...props }),
                effectiveIsOpen ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { ref: closeIconRef, className: "tab absolute min-w-[40px] top-0 px-[8px] right-[0px] z-[9999] text-center \r\n                h-[100%] cursor-pointer flex items-center justify-center", onFocus: () => setIsDropDownOpen(true), onBlur: handleBlur, tabIndex: 0, onClick: handleClose },
                        react_1.default.createElement("div", { "aria-label": closeLabel, className: "text-[14px] icon icon-close" })),
                    overlay && react_1.default.createElement("div", { className: "overlay fixed w-full h-full z-[8] top-0 left-0 right-0 bg-[#4C4C4C80]/[.5]", onClick: closeDropDown }))) : (react_1.default.createElement("div", { className: "open-button absolute min-w-[40px] top-0 px-[8px] right-[0px] z-[9999] text-center \r\n              h-[100%] cursor-pointer flex items-center justify-center", onClick: openDropdown },
                    react_1.default.createElement("button", { type: "submit", "aria-label": submitLabel },
                        react_1.default.createElement("span", { className: "text-[18px] icon icon-search" }))))),
            autoSuggestion),
        react_1.default.createElement("div", { ref: dropDownRef, className: `dropDown bg-brandWhite pt-[12px] z-[9999] mt-[1px] absolute w-[100%] pb-[24px] ${effectiveIsOpen ? 'visible' : 'hidden'}`, tabIndex: -1, onFocus: () => setIsDropDownOpen(true), onBlur: handleBlur, onScroll: handleScroll },
            react_1.default.createElement("div", { className: "dropDown-content" },
                react_1.default.createElement("div", { className: "dropDown-body" }, children)))));
};
exports.AutoComplete = AutoComplete;
